import React from 'react';

import { useViewController } from '../context';
import CloseIcon from './icons/CloseIcon';

export default function CloseButton() {
  const { close } = useViewController();

  return (
    <button
      onClick={close}
      autoFocus
      css={{
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        transition: 'opacity 0.2s',
        padding: 6,
        lineHeight: 0,
        opacity: 0.7,
        '&:hover': { opacity: 1 },
        '&:focus': { outline: '1px solid rgba(255,255,255,0.3)' },
      }}
    >
      <CloseIcon />
    </button>
  );
}
